import React,{Component} from 'react';
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QMainProductViewPrint extends Component{
    
    

    render() {  
            var thick = this.props.product.productThickness
                thick = thick.slice(-3)
        return (
                <tr>
                    <td className="pName">{this.props.product.productName}</td>
                    <td className="pDimension">0.{thick}x{this.props.product.productDimension}</td>                   
                    <td className="pQtyPUnit">{formatQuantity(this.props.product.productNumber)}</td>                    
                    <td className="unitAlone">{this.props.product.productUnit}</td>

                    <td className="pPricePunit">{formatPrice(this.props.product.productPrice)}</td>                    
                    <td className="priceUnitAlone">/{this.props.product.productUnit}</td>

                    <td className="pDisc">{this.props.product.productDiscount}%</td>
                    <td className="pAmount">{formatPrice(this.props.product.productTotal)}</td>
                </tr>
                    
 
        );
    }
}

export default  QMainProductViewPrint;


// WEBPACK FOOTER //
// ./src/components/QMainProductViewPrint.js